export default __webpack_public_path__ + "static/output_gif-77a921b8c98d2d176452cb16a9b3f9ca.gif";